import React, { useContext, useEffect } from 'react';
import uuid from 'uuidv4';
import AddItemBtn from '../btn/addItemBtn';
import { BuildContext } from '../../Data/Context/buildData';
import { PokedexContext } from '../../Data/Context/pokemonData';
import { LanguageContext } from '../../Data/Context/languageContext';

const Abilities = ({ itemType, modal, numberOfItems, itemCategory }) => {
    /* Data Context */
    const { buildMode, buildDataFromDB, clearAbilities } = useContext(BuildContext);
    const { pokemonData } = useContext(PokedexContext);
    const { t } = useContext(LanguageContext);

    /* Variables */
    let btnIndex = 0;
    const mainAbilities = [];
    const optionalAbilities = [];
    const pokemonMainAbilities = [];
    const pokemonOptionalAbilities = [];
    const pokemonMainAbilitiesArray = [];
    const pokemonOptionalAbilitiesArray = [];

    let offset
    pokemonData.numberOf.abilities === 2 ? offset = 2 : offset = 0;

    /* Functions */
    function btnIndexer() {
        btnIndex++
    }

    /* Data building */
    if (buildDataFromDB) {
        for (let index = 1; index <= 4; index++)
            if (buildDataFromDB.abilities['ability_' + index])
                pokemonMainAbilities.push(buildDataFromDB.abilities['ability_' + index])

        for (let index = 5; index <= 8; index++)
            if (buildDataFromDB.abilities['ability_' + index])
                pokemonOptionalAbilities.push(buildDataFromDB.abilities['ability_' + index])
    } else {
        for (var i = 1; i <= numberOfItems; i++)
            mainAbilities.push(`${itemCategory} ${i}`)

        for (var j = 1; j <= numberOfItems; j++)
            optionalAbilities.push(`${itemCategory} ${j}`)
    }

    if (buildDataFromDB) {
        if (pokemonData.numberOf.abilities === 2) {
            for (let index = 1; index <= 2; index++)
                buildDataFromDB.abilities['ability_' + index] !== "" ? pokemonMainAbilitiesArray.push(buildDataFromDB.abilities['ability_' + index]) : pokemonMainAbilitiesArray.push("")
            for (let index = 5; index <= 6; index++)
                buildDataFromDB.abilities['ability_' + index] !== "" ? pokemonOptionalAbilitiesArray.push(buildDataFromDB.abilities['ability_' + index]) : pokemonOptionalAbilitiesArray.push("")
        } else {
            for (let index = 1; index <= 4; index++)
                buildDataFromDB.abilities['ability_' + index] !== "" ? pokemonMainAbilitiesArray.push(buildDataFromDB.abilities['ability_' + index]) : pokemonMainAbilitiesArray.push("")
            for (let index = 5; index <= 8; index++)
                buildDataFromDB.abilities['ability_' + index] !== "" ? pokemonOptionalAbilitiesArray.push(buildDataFromDB.abilities['ability_' + index]) : pokemonOptionalAbilitiesArray.push("")
        }
    }

    useEffect(() => {
        if (buildMode === 'building') {
            clearAbilities();
        }
        // eslint-disable-next-line
    }, [pokemonData]);

    return (
        <>
            {(buildMode === 'building') &&
                <>
                    <div className={`col-12 options text-center mb-3`}><b>{t("option")} 1</b></div>
                    {mainAbilities.map((item, index) => (
                        <div key={uuid()} className={`itemSquare`}>
                            {btnIndexer()}
                            <AddItemBtn classes={'mx-2 mx-sm-4'} itemType={itemType} btnIndex={btnIndex} index={index + 1} modal={modal}></AddItemBtn>
                        </div>
                    ))}

                    <div className={`col-12 options text-center mb-3`}><b>{t("option")} 2</b></div>

                    {optionalAbilities.map((item, index) => (
                        <div key={uuid()} className={`itemSquare`}>
                            {btnIndexer()}
                            <AddItemBtn classes={'mx-2 mx-sm-4'} itemType={itemType} btnIndex={btnIndex + offset} index={index + 1} modal={modal}></AddItemBtn>
                        </div>
                    ))}
                </>
            }

            {(buildMode === 'editing') &&
                <>
                    <div className={`col-12 options text-center mb-3`}><b>{t("option")} 1</b></div>
                    {pokemonMainAbilitiesArray.map((item, index) => (
                        <div key={uuid()} className={`itemSquare`}>
                            {btnIndexer()}
                            <AddItemBtn classes={'mx-2 mx-sm-4'} imgSrc={item} itemType={itemType} btnIndex={btnIndex} index={index + 1} modal={modal}></AddItemBtn>
                        </div>
                    ))}

                    <div className={`col-12 options text-center mb-3`}><b>{t("option")} 2</b></div>
                    {pokemonOptionalAbilitiesArray.map((item, index) => (
                        <div key={uuid()} className={`itemSquare`}>
                            {btnIndexer()}
                            <AddItemBtn classes={'mx-2 mx-sm-4'} imgSrc={item} itemType={itemType} btnIndex={btnIndex + offset} index={index + 1} modal={modal}></AddItemBtn>
                        </div>
                    ))}
                </>
            }

            {(buildMode === 'viewing') &&
                <>
                    <div className={`col-12 options text-center mb-3`}><b>{t("option")} 1</b></div>
                    {pokemonMainAbilities.map((item, index) => (
                        <div key={uuid()} className={`itemSquare`}>
                            {btnIndexer()}
                            <AddItemBtn classes={'mx-2 mx-sm-4'} itemType={'ability'} btnIndex={btnIndex} index={index + 1} imgSrc={item} ></AddItemBtn>
                        </div>
                    ))}

                    {buildDataFromDB && buildDataFromDB.abilities.ability_5 &&
                        <>
                            <div className={`col-12 options text-center mb-3`}><b>{t("option")} 2</b></div>
                            {pokemonOptionalAbilities.map((item, index) => (
                                <div key={uuid()} className={`itemSquare`}>
                                    {btnIndexer()}
                                    <AddItemBtn classes={'mx-2 mx-sm-4'} itemType={'ability'} btnIndex={btnIndex} index={index + 1} imgSrc={item}></AddItemBtn>
                                </div>
                            ))}
                        </>
                    }
                </>
            }
        </>
    );
}
export default Abilities;